/*!*
 * @author yueheqin
 * @date 2019/7/10
 * @project zujuanzaixian
 * @desc 试题篮
 */
import {QUES_BASKET_KEY, CURRENT_SUBJECT, PAPER_CFG} from '../../config'
import { getLocalItem, setLocalItem } from '../../utils/storage'
import {Notification, Message} from 'element-ui'
import Vue from 'vue'
import {objectToArray} from '../../utils'
import _ from 'lodash'
import {paperviewCfgApi} from '../../api/zujuan'
import { createKeyMap } from '../../utils/create-maps'

let state = {
  quesBasket: getLocalItem(QUES_BASKET_KEY) || {}, // 试题篮
  paperCfg: getLocalItem(PAPER_CFG) || {} // 试卷配置
}
let getters = {
  quesBasket (state) {
    return state.quesBasket
  },
  paperCfg (state) {
    return state.paperCfg
  },
  quesBasketSubjectSum (state) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    if (_.size(state.quesBasket[subjectID])) {
      let num = 0
      _.each(state.quesBasket[subjectID], item => {
        num += item.testNum
      })
      return num
    } else {
      return 0
    }
  },
  quesBasketTypeList (state) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    let temp = _.map(state.quesBasket[subjectID], item => {
      return {
        typesID: item.typesID,
        typesName: item.typesName,
        testID: item.testID,
        testNum: item.testNum
      }
    })
    return objectToArray(temp, 'typesID')
  },
  quesSubjectTypeListMap (state) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    return createKeyMap(state.paperCfg[subjectID].typesList, 'id')
  }
}
let mutations = {
  // 初始化试题篮
  initQuesBasket (state, val) {
    if (_.isEmpty(state.quesBasket)) {
      _.each(val, item => {
        state.quesBasket[item.subjectID] = {}
      })
      setLocalItem(QUES_BASKET_KEY, state.quesBasket)
    }
  },
  // 初始化试卷配置
  initPaperCfg (state, val) {
    if (_.isEmpty(state.paperCfg)) {
      _.each(val, item => {
        state.paperCfg[item.subjectID] = {}
      })
      setLocalItem(PAPER_CFG, state.paperCfg)
    }
  },
  updateQuesBasket (state, val) {
    // 为了触发视图改变
    state.quesBasket = Object.assign({}, state.quesBasket)
  },
  updatePaperCfg (state, val) {
    // 为了触发视图改变
    state.paperCfg = Object.assign({}, state.paperCfg)
  },
  // 试题篮 试卷设置
  addPaperCfg (state, val) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    // 组卷生成试卷传递过来的数据只有paper
    state.paperCfg[subjectID] = val.paperStyle ? _.assign({}, {defaultPaper: val.defaultPaper, typesList: val.typesList, paperStyle: val.paperStyle}) : _.assign({}, state.paperCfg[subjectID], {defaultPaper: val})
    // debugger
    setLocalItem(PAPER_CFG, state.paperCfg)
  },
  // 添加到试题篮 val为试题详情item
  addQuesBasket (state, val) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    let quesBasketSubject = state.quesBasket[subjectID]
    if (quesBasketSubject[val.testID]) {
      Message({
        type: 'warning',
        message: '该试题已经在试题篮里'
      })
      return
    } else {
      Vue.set(quesBasketSubject, val.testID, val)
    }
    // 为了触发视图改变
    state.quesBasket = Object.assign({}, state.quesBasket)
    setLocalItem(QUES_BASKET_KEY, state.quesBasket)
    Notification({
      type: 'success',
      title: '提示',
      message: '加入试题成功'
    })
  },
  // 试卷 - 全部加入到试题篮
  addAllQuesBasket (state, val) {
    let items = val.silent ? val.val : val
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    let quesBasketSubject = state.quesBasket[subjectID]
    _.each(items, item => {
      Vue.set(quesBasketSubject, item.testID, item)
    })
    // 为了触发视图改变
    state.quesBasket = Object.assign({}, state.quesBasket)
    setLocalItem(QUES_BASKET_KEY, state.quesBasket)
    if (!val.silent) {
      Notification({
        type: 'success',
        title: '提示',
        message: '全部加入试题篮成功'
      })
    }
  },
  // 移除试题篮 val 为 item
  removeQuesBasket (state, val) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    let quesBasketSubject = state.quesBasket[subjectID]
    if (quesBasketSubject[val.testID]) {
      delete quesBasketSubject[val.testID]
      // 为了触发视图改变
      state.quesBasket = Object.assign({}, state.quesBasket)
    } else {
      Message({
        type: 'warning',
        message: '试题篮里不存在该试题'
      })
      return
    }
    setLocalItem(QUES_BASKET_KEY, state.quesBasket)
    Notification({
      type: 'success',
      title: '提示',
      message: '移除试题成功'
    })
  },
  // 清空试题篮
  clearQuesBasket (state, val) {
    // 如果silent = 1，静默，不出提示框
    let subjectID = val.silent ? val.subjectID : val
    state.quesBasket[subjectID] = {}
    // 为了触发视图改变
    state.quesBasket = Object.assign({}, state.quesBasket)
    setLocalItem(QUES_BASKET_KEY, state.quesBasket)
    if (!val.silent) {
      Notification({
        type: 'success',
        title: '提示',
        message: '清除试题篮成功'
      })
    }
  },
  // 删除某一类型的试题
  removeBasketType (state, items) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    _.each(items, item => {
      delete state.quesBasket[subjectID][item.testID]
    })
    // 为了触发视图改变
    state.quesBasket = Object.assign({}, state.quesBasket)
    setLocalItem(QUES_BASKET_KEY, state.quesBasket)
    Notification({
      type: 'success',
      title: '提示',
      message: '删除成功'
    })
  },
  // 给试题加入到试卷中 val 为item
  addTypeCompose (state, val) {
    let subjectID = getLocalItem(CURRENT_SUBJECT).id
    let typesList = state.paperCfg[subjectID].typesList
    // 此处用val.typesID找类型，需要给id转换成string类型
    let quesType = _.find(typesList, {id: val.typesID + ''}) // 本题类型数据
    let volume = quesType.volume // 本类型属于第几卷
    let typeCompose = _.find(state.paperCfg[subjectID].defaultPaper.typeCompose, {id: volume}) // 所属卷的试卷结构
    let typeComposeSub = _.find(typeCompose.sub, {id: quesType.id}) // 所属卷的试卷结构该类型题
    if (_.size(typeComposeSub) && _.findIndex(typeComposeSub.sub, {testID: val.testID}) == -1) { // 如果存在该类型而且没有存该题 直接给数据push到sub中
      typeComposeSub.sub.push({
        testID: val.testID,
        testNum: val.testNum,
        diff: val.diff,
        diffName: val.diffName,
        chooseGroup: 0,
        chooseNum: 0,
        score: quesType.typesScore == 1 ? _.fill(Array(val.testNum), Number(quesType.dScore)) : _.fill(Array(val.testNum), _.floor(quesType.dScore / val.testNum)) // quesType.typesScore ,  1按小题计分，2按大题计分，计算每道题分值-数组类型
        // score: _.fill(Array(val.testNum), Number(quesType.dScore))
      })
    } else if (!_.size(typeComposeSub)) { // 如果不存在该类型的题，push该题型，再push该题
      typeCompose.sub.push({
        id: quesType.id,
        name: quesType.name,
        isShow: 1,
        notes: quesType.notes,
        isShowScore: 1,
        sub: [{
          testID: val.testID,
          testNum: val.testNum,
          diff: val.diff,
          diffName: val.diffName,
          chooseGroup: 0,
          chooseNum: 0,
          score: quesType.typesScore == 1 ? _.fill(Array(val.testNum), Number(quesType.dScore)) : _.fill(Array(val.testNum), _.floor(quesType.dScore / val.testNum)) // quesType.typesScore ,  1按小题计分，2按大题计分，计算每道题分值-数组类型
          // score: _.fill(Array(val.testNum), Number(quesType.dScore))
        }]
      })
    }
    state.paperCfg[subjectID].defaultPaper.typeCompose = state.paperCfg[subjectID].defaultPaper.typeCompose.splice(0) // 触发视图更新
    setLocalItem(PAPER_CFG, state.paperCfg)
  },
  // 试卷结构中移清除所有试题
  clearTypeCompose (state, subjectID) {
    _.each(state.paperCfg[subjectID].defaultPaper.typeCompose, item => {
      item.sub = []
    })
    state.paperCfg[subjectID].defaultPaper.typeCompose = state.paperCfg[subjectID].defaultPaper.typeCompose.splice(0)
    setLocalItem(PAPER_CFG, state.paperCfg)
  }
  // 试卷结构中移除相应的试题 val为item
  // removeTypeCompose (state, val) {
  //   let subjectID = getLocalItem(CURRENT_SUBJECT).id
  //   let typesList = state.paperCfg[subjectID].typesList
  //   let quesType = _.find(typesList, {id: val.typesID + ''}) // 本题类型数据
  //   let volume = quesType.volume // 本类型属于第几卷
  //   let typeCompose = _.find(state.paperCfg[subjectID].defaultPaper.typeCompose, {id: volume}) // 所属卷的试卷结构
  //   let typeComposeSub = _.find(typeCompose.sub, {id: quesType.id}) // 所属卷的试卷结构该类型题
  //   typeComposeSub.sub.splice(_.findIndex(typeComposeSub, {testID: val.testID}), 1) // 删除试题
  //   if (typeComposeSub.sub.length == 0) {
  //     typeCompose.sub.splice(_.findIndex(typeCompose.sub, {id: quesType.id}), 1)
  //   }
  //   state.paperCfg[subjectID].defaultPaper.typeCompose = _.assign({}, state.paperCfg[subjectID].defaultPaper.typeCompose)
  //   setLocalItem(PAPER_CFG, state.paperCfg)
  // },
}
let actions = {
  // 获取各科组卷配置
  getSubjectPaperConfig ({ state, commit, rootGetters }) {
    let subjectID = rootGetters['common/currentSubject'].id
    return new Promise((resolve, reject) => {
      paperviewCfgApi({subjectID}).then((res) => {
        let data = res.data
        commit('addPaperCfg', data)
        // 如果没有保存下载配置数据，则保存
        if (!_.size(rootGetters['zujuan/wordDownConfig'])) {
          commit('zujuan/saveWordDownConfig', data.docDown, {root: true})
        }
        resolve(data)
      }).catch(err => {
        reject(err)
      })
      // if (!_.size(state.paperCfg[subjectID])) {
      // } else {
      //   resolve(state.paperCfg[subjectID])
      // }
    }, (hand) => {
      alert('handler')
      console.log(hand, 'hand')
    })
    // if (!_.size(rootGetters['zujuan/wordDownConfig'])) {
    //   paperviewCfgApi({subjectID}).then(({data}) => {
    //     commit('zujuan/saveWordDownConfig', data.docDown, {root: true})
    //   })
    // }
  },
  // // 加入试题篮，同时加入试卷结构
  // addQuesAction ({state, commit}, payload) {
  //   commit('addQuesBasket', payload)
  //   commit('addTypeCompose', payload)
  // },
  // // 全部加入试题篮，同时加入试卷结构
  // addAllAction ({state, commit}, payload) {
  //   let items = payload.silent ? payload.val : payload
  //   commit('addAllQuesBasket', payload)
  //   _.each(items, item => {
  //     commit('addTypeCompose', item)
  //   })
  // },
  // // 删除试题篮中试题，同时删除试卷结构对应试题
  // removeQuesAction ({state, commit}, payload) {
  //   commit('removeQuesBasket', payload)
  //   commit('removeTypeCompose', payload)
  // },
  // // 清空试题篮中试题，同时清空试卷结构对应试题
  // clearAction ({state, commit}, payload) {
  //   commit('clearQuesBasket', payload)
  //   commit('clearTypeCompose', payload)
  // },
  // // 清空某一类型试题篮中试题，同时删除试卷结构对应试题
  // removeTypeAction ({state, commit}, payload) {
  //   commit('removeBasketType', payload)
  //   _.each(payload, item => {
  //     commit('removeTypeCompose', item)
  //   })
  // },
  // 组卷替换掉试题篮中的数据
  replaceBasketAction ({state, commit, dispatch, rootGetters}, payload) {
    let subjectID = rootGetters['common/currentSubject'].id
    commit('addPaperCfg', payload.paper)
    commit('clearQuesBasket', {subjectID, silent: '1'})
    commit('addAllQuesBasket', {val: payload.testList, silent: '1'})
    // dispatch('addAllAction', {val: payload.testList, silent: '1'})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
